export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "首页",
    layout: null
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {

}

export default {
    en: {

    },
    zh: {

    }
}